import PropTypes from 'prop-types'
import React from 'react'
import './CounterBadge.less'

const classNames = require('classnames')

const PLUS = '+'

export default class CounterBadge extends React.Component {
  static isValidNumber (limit) {
    return typeof limit === 'number' && isFinite(limit)
  }
  render () {
    const lower = this.props.lowerLimit
    const upper = this.props.upperLimit
    const classes = classNames('nmc-counter-badge', `nmc-counter-badge-${this.props.background}`, this.props.className)
    // try to convert any value to number by +, if not a number then counter will be NaN
    const counter = +this.props.children
    if (!CounterBadge.isValidNumber(counter) || (CounterBadge.isValidNumber(lower) && counter < lower)) {
      return null
    }
    return (
      <span className={classes}>
        {(CounterBadge.isValidNumber(upper) && counter > upper) ? upper + PLUS : counter}
      </span>
    )
  }
}

CounterBadge.propTypes = {
  upperLimit: PropTypes.number,
  lowerLimit: PropTypes.number,
  background: PropTypes.string
}




// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/CounterBadge/index.js